/* src/app/main/performance/list/performance-list.component.scss */
:host ::ng-deep pageable-table td:nth-child(3) {
  white-space: pre-line;
  vertical-align: top;
}
/*# sourceMappingURL=performance-list.component-FZLU2LB5.css.map */
